import { MessageProps, MessageValidationProps, sendMessageRequest, validateMessageAPIRequest } from "./SendMessageAPI";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../../../store";
import { ChatAreaProps } from "../../../../Models/ChatAreaProps";

// Define a type for the slice state
interface CounterState {
  isFetching: boolean;
  status: "IDLE" | "PENDING" | "SUCCESS" | "FAILED";
  chatResponse: ChatAreaProps[];
  error: any;
  isFetchingMessageValidation: boolean;
  messageValidationStatus: "IDLE" | "PENDING" | "SUCCESS" | "FAILED";
  messageValidationResponse: any;
  messageValidationError: any;
}

// Define the initial state using that type
const initialState: CounterState = {
  isFetching: false,
  status: "IDLE",
  chatResponse: [],
  error: {},
  isFetchingMessageValidation: false,
  messageValidationStatus: "IDLE",
  messageValidationResponse: {},
  messageValidationError: {},
};

export const sendChatMessage = createAsyncThunk("sendMesssage/Chat", async (message: MessageProps) => {
  return await sendMessageRequest(message);
});

export const validateMessageRequest = createAsyncThunk(
  "sendMesssage/validate",
  async (message: MessageValidationProps) => {
    return await validateMessageAPIRequest(message);
  }
);

// Then, handle actions in your reducers:
// Then, handle actions in your reducers:
const sendMessageSlice = createSlice({
  name: "sendChatMessage",
  initialState: initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    clearSendChatMessage: (state) => {
      state.isFetching = false;
      state.status = "IDLE";
      state.chatResponse = [];
    },
    clearMessageValidation: (state) => {
      state.isFetchingMessageValidation = false;
      state.messageValidationStatus = "IDLE";
      state.messageValidationResponse = {};
      state.messageValidationError = {};
    },
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(sendChatMessage.pending, (state) => {
        state.status = "PENDING";
        state.isFetching = true;
      })
      .addCase(sendChatMessage.fulfilled, (state, action) => {
        // Add user to the state array
        state.status = "SUCCESS";
        state.isFetching = false;
        state.chatResponse = action.payload;
      })
      .addCase(sendChatMessage.rejected, (state, action: any) => {
        state.status = "FAILED";
        state.isFetching = false;
        // Parse the error message from XML and extract the content within <message> tags
        const errorXml = new DOMParser().parseFromString(action.error.message, "text/xml");
        const errorMessage = errorXml.querySelector("message")?.textContent || "An error occurred";
        state.error = errorMessage;
      })
      .addCase(validateMessageRequest.pending, (state) => {
        state.messageValidationStatus = "PENDING";
        state.isFetchingMessageValidation = true;
      })
      .addCase(validateMessageRequest.fulfilled, (state, action) => {
        // Add user to the state array
        state.messageValidationStatus = "SUCCESS";
        state.isFetchingMessageValidation = false;
        state.messageValidationResponse = action.payload;
      })
      .addCase(validateMessageRequest.rejected, (state, action: any) => {
        state.messageValidationStatus = "FAILED";
        state.isFetchingMessageValidation = false;
        // Parse the error message from XML and extract the content within <message> tags
        const errorXml = new DOMParser().parseFromString(action.error.message, "text/xml");
        const errorMessage = errorXml.querySelector("message")?.textContent || "An error occurred";
        // console.log("=== errorMessage - validation ===", errorMessage);
        
        state.messageValidationError = errorMessage;
      });
  },
});

export const sendChatMessageSelector = (state: RootState) => state.sendChatMessage;

export const { clearSendChatMessage } = sendMessageSlice.actions;
export default sendMessageSlice.reducer;
